import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Link } from "wouter";
import { caseStudyFacilityImage } from "@/data/site";

const focusAreas = [
  "Facility design and member flow",
  "Equipment planning and zoning",
  "Operational readiness before opening",
];

export function CaseStudies() {
  return (
    <section className="case-studies" aria-labelledby="case-studies-title">
      <div className="site-container">
        <div className="case-studies__heading">
          <div>
            <p className="eyebrow">Selected work</p>
            <h2 id="case-studies-title">Better facility decisions<br /><em>start on the floor.</em></h2>
          </div>
          <p>
            Altitude brings design, operations, and the member experience into the same conversation—so facilities look sharp, work hard, and are easier to operate from day one.
          </p>
        </div>

        <article className="case-study-feature">
          <div className="case-study-feature__image">
            <img src={caseStudyFacilityImage} alt="Modern fitness facility from Altitude’s legacy portfolio" loading="lazy" />
            <span>Legacy portfolio facility image</span>
          </div>
          <div className="case-study-feature__copy">
            <p className="eyebrow">Facility design &amp; build-out</p>
            <h3>Designed around the way members move.</h3>
            <p>
              Effective fitness facilities connect equipment, traffic flow, maintenance access, and the experience a member feels from the first visit. Our work keeps those decisions connected from the concept phase through operational launch.
            </p>
            <ul>
              {focusAreas.map(area => <li key={area}><CheckCircle2 size={17} />{area}</li>)}
            </ul>
            <Link href="/facility-services" className="inline-link">Explore facility services <ArrowRight size={16} /></Link>
            <p className="case-study-feature__note">Client names and private performance data are published only with written approval.</p>
          </div>
        </article>
      </div>
    </section>
  );
}
